// ---------------------------------------------------------------------------
// Wire vocabulary the store speaks. Kept structural on purpose: the middleware and the public
// `@wix/comments` SDK use the same string values, and the store must depend on neither package's
// generated types (see `vote-service-mappers.ts`). The comments service casts these at its
// boundary to whichever client it calls.
// ---------------------------------------------------------------------------
/** Enrichment blocks a comments read can ask for. */
export const Fieldset = {
    UNKNOWN_FIELDSET: 'UNKNOWN_FIELDSET',
    MEMBERS: 'MEMBERS',
    CURRENT_MEMBER: 'CURRENT_MEMBER',
    REACTIONS: 'REACTIONS',
    REGISTRATION_DATA: 'REGISTRATION_DATA',
    MEMBER_ROLES: 'MEMBER_ROLES',
    MEMBER_BADGES: 'MEMBER_BADGES',
    TOTAL_COMMENTS: 'TOTAL_COMMENTS',
    FOLLOWED_MEMBERS: 'FOLLOWED_MEMBERS',
    VOTES: 'VOTES',
    CURRENT_RATING: 'CURRENT_RATING',
    RATINGS_SUMMARY: 'RATINGS_SUMMARY',
    BLOCKED_MEMBERS: 'BLOCKED_MEMBERS',
    CONTEXT_PERMISSIONS: 'CONTEXT_PERMISSIONS',
};
export const MemberRole = {
    UNKNOWN_ROLE: 'UNKNOWN_ROLE',
    FORUM_MODERATOR: 'FORUM_MODERATOR',
    BLOG_WRITER: 'BLOG_WRITER',
    BLOG_EDITOR: 'BLOG_EDITOR',
    BLOCKED: 'BLOCKED',
    OWNER: 'OWNER',
    CONTRIBUTOR: 'CONTRIBUTOR',
};
export const CommentOrder = {
    UNKNOWN_ORDER: 'UNKNOWN_ORDER',
    OLDEST_FIRST: 'OLDEST_FIRST',
    NEWEST_FIRST: 'NEWEST_FIRST',
    REACTION_COUNT: 'REACTION_COUNT',
    NET_VOTE_COUNT: 'NET_VOTE_COUNT',
    RATING: 'RATING',
    NET_VOTE_COUNT_ASC: 'NET_VOTE_COUNT_ASC',
    RATING_ASC: 'RATING_ASC',
};
export const ReplySortOrder = {
    UNKNOWN_ORDER: 'UNKNOWN_ORDER',
    OLDEST_FIRST: 'OLDEST_FIRST',
    NEWEST_FIRST: 'NEWEST_FIRST',
    REACTION_COUNT: 'REACTION_COUNT',
};
export const ReasonType = {
    UNKNOWN_TYPE: 'UNKNOWN_TYPE',
    OTHER: 'OTHER',
    SPAM: 'SPAM',
    NUDITY_OR_SEXUAL_HARASSMENT: 'NUDITY_OR_SEXUAL_HARASSMENT',
    HATE_SPEECH_OR_SYMBOLS: 'HATE_SPEECH_OR_SYMBOLS',
    FALSE_INFORMATION: 'FALSE_INFORMATION',
    COMMUNITY_GUIDELINES_VIOLATION: 'COMMUNITY_GUIDELINES_VIOLATION',
    VIOLENCE: 'VIOLENCE',
};
//# sourceMappingURL=comments-service-types.js.map